export const SET_DIRECTORS_LOAN_WIDGET_LOADING = 'SET_DIRECTORS_LOAN_WIDGET_LOADING';
export const SET_DIRECTORS_LOAN_WIDGET_RESULTS = 'SET_DIRECTORS_LOAN_WIDGET_RESULTS';
export const SET_DIRECTORS_LOAN_DETAILS_LOADING = 'SET_DIRECTORS_LOAN_DETAILS_LOADING';
export const SET_DIRECTORS_LOAN_DETAILS_RESULTS = 'SET_DIRECTORS_LOAN_DETAILS_RESULTS';
